// Privacy and Terms links, under the pre-join settings. Sign out and Delete
// account used to sit here too; Adam, 2026-10-10, took them off this surface.

import { type JSX } from "react";
import { linkHandler } from "../lib/nav";

/** Privacy and Terms, under the settings. */
export function LegalLinks(): JSX.Element {
  return (
    <p className="muted" style={{ margin: 0, fontSize: 13, textAlign: "center" }}>
      <a href="/privacy" onClick={linkHandler("/privacy")} style={{ textDecoration: "none", display: "inline-block", padding: "12px 8px" }}>
        Privacy
      </a>
      <a href="/terms" onClick={linkHandler("/terms")} style={{ textDecoration: "none", display: "inline-block", padding: "12px 8px" }}>
        Terms
      </a>
    </p>
  );
}
